// ======================================================================
// File Name       : ContentLinkRegisterContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isInvalid } from 'redux-form';
import $ from 'jquery';
import * as MessageTemplate from '../../constants/MessageTemplate';
import ContentLinkRegister from '../../components/content/ContentLinkRegister';
import { contentLinkEdit, searchContentLinkList } from '../../actions/content/ContentLinkAction';
import { SELECT_TARGET_DATA, MODE } from '../../constants/index';
import ContentLinkConfirmDialog from '../../components/content/ContentLinkConfirmDialog';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class ContentLinkRegisterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contentSecernId: '',
      contentName: '',
      linkURL: '',
      redirectToList: false,
      editType: MODE.NEW_MODE,
      contentLink: {},
      showDialogConfirm: false,
    };
    this.onRegisterBtnClick = this.onRegisterBtnClick.bind(this);
    this.onCancelRegisterBtnClick = this.onCancelRegisterBtnClick.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
  }

  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      const contentSecernId = match.params.id;
      this.getContentLink(contentSecernId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { content, match, redirectToList } = nextProps;
    const { contentLinkInfo } = content;
    const contentLinkDetail =
      contentLinkInfo &&
      $.grep(contentLinkInfo.linkContentList, e => e.contentSecernId === match.params.id);
    if (contentLinkDetail && contentLinkDetail.length > 0) {
      this.setState({
        editType: MODE.EDIT_MODE,
        contentLink: contentLinkDetail[0],
      });
    } else {
      this.setState({ redirectToList });
    }
  }

  getContentLink(contentSecernId) {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        contentSecernIdList: [contentSecernId],
      },
    };

    this.props.dispatch(searchContentLinkList(param));
  }

  onRegisterBtnClick() {
    this.setState({ showDialogConfirm: false });
    const { history, contentLinkRegister } = this.props;
    if (!contentLinkRegister.syncErrors || contentLinkRegister.syncErrors.length === 0) {
      const contentLinkRegisterInfo = contentLinkRegister.values;
      const param = {
        editType: this.state.editType,
        linkContentInfo: {
          contentSecernId: contentLinkRegisterInfo && contentLinkRegisterInfo.contentSecernId ?
          contentLinkRegisterInfo.contentSecernId : null,
          contentName: contentLinkRegisterInfo && contentLinkRegisterInfo.contentName,
          linkUrl: contentLinkRegisterInfo && contentLinkRegisterInfo.linkUrl,
        },
      };

      this.props.dispatch(contentLinkEdit(param)).then(() => {
        // back to content link list
        history.push(Path.CONTENT_LINK_LIST);
      });
    }
  }

  showDialog() {
    if (!this.props.invalid) {
      this.setState({ showDialogConfirm: true });
    }
  }

  hideDialog() {
    this.setState({ showDialogConfirm: false });
  }

  onCancelRegisterBtnClick() {
    this.props.history.goBack();
  }

  render() {
    const { match } = this.props;
    const isEditMode = !!match.params.id;
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_LINK_LIST}
          text="リンク一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name={isEditMode ? 'リンクの編集' : 'リンクの追加'} />
        <ContentLinkRegister
          {...this.state}
          isEditMode={isEditMode}
          onRegisterBtnClick={this.showDialog}
          onCancelRegisterBtnClick={this.onCancelRegisterBtnClick}
        />
        <ContentLinkConfirmDialog
          showModal={this.state.showDialogConfirm}
          handleOkClick={this.onRegisterBtnClick}
          handleCancelClick={this.hideDialog}
          contentLink={
            this.props.contentLinkRegister ? this.props.contentLinkRegister.values : null
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { contentLinkRegister } = state.form;
  const { content } = state;
  const invalid = isInvalid('contentLinkRegister')(state);
  return {
    content,
    redirectToList: state.content.redirectToList,
    contentLinkRegister,
    invalid,
  };
};

export default connect(mapStateToProps)(ContentLinkRegisterContainer);
